import { lighten } from '@mui/material';

import { IconButton, ReceiptIcon, IconButtonProps } from '@occc-app/design-system';

export const FraudulentIconButton = ({
  onClick,
  sx,
}: {
  onClick?: IconButtonProps['onClick'];
  sx: IconButtonProps['sx'];
}) => {
  return (
    <IconButton
      onClick={onClick}
      sx={{
        backgroundColor: ({ palette }) => lighten(palette.primary.main, 0.8),
        borderRadius: '50%',
        p: 0.5,
        transition: 'background-color 0.3s',
        '&:hover': {
          backgroundColor: ({ palette }) => lighten(palette.primary.main, 0.7),
        },
        ...sx,
      }}
    >
      <ReceiptIcon color='primary' fontSize='small' />
    </IconButton>
  );
};
